module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="selecteurActiviteCompleteView">\r\n</div>';
}
return __p;
};
